import { Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import ResponsiveImage from "components/ResponsiveImage";

export const ContentWrapper = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  position: "absolute",
  bottom: 0,
  background: "linear-gradient(180deg, transparent 50%, rgba(0, 0, 0, 0.8) 100%)",
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  [theme.breakpoints.down("mobile")]: {
    fontSize: 12,
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  overflow: "hidden",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  marginBottom: 10,
  width: "100%",
  [theme.breakpoints.down("mobile")]: {
    fontSize: 9,
    marginBottom: 0,
  },
}));

export const Logo = styled(ResponsiveImage)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  [theme.breakpoints.down("mobile")]: {
    width: "auto",
  },
}));

export const InactiveOverlay = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.3)",
}));
